import {
  CARD_TYPES,
  CARD_TYPES_WITH_INFO_BANNER,
  CARD_TYPES_WITH_PROOF,
} from 'cards/constants/CardTypes';

import { PRODUCT_OPTION_DETAILS, TYPE_OPTION_DETAILS } from 'cards/constants/CardLevelOptions';

export const matchOptionDetails = (option, optionType) =>
  optionType === 'type' ? TYPE_OPTION_DETAILS[option] : PRODUCT_OPTION_DETAILS[option];

export const enrichQtyOptions = (min, max, increment = 1) => {
  const options = [];
  if (min && max) {
    for (let i = min; i <= max; i += increment) {
      options.push({ label: i.toString(), value: i });
    }
  }
  return options;
};

export const hasSingleSizeOption = availableOptions => {
  return (
    availableOptions &&
    availableOptions.size.options.filter(each => {
      return each.enabled;
    }).length === 1
  );
};

export const getInformationBannerVisibility = cardType =>
  CARD_TYPES_WITH_INFO_BANNER.includes(cardType);

export const cardHasProof = cardType => CARD_TYPES_WITH_PROOF.includes(cardType);

export const getEnabledSizeOptions = (optionList, cardType, foil) => {
  return optionList.filter(option => {
    // TODO: remove this at the BE level
    if (foil && [CARD_TYPES.std].includes(cardType) && option.value === 'postcard') {
      return false;
    }
    return option.enabled;
  });
};



// WEBPACK FOOTER //
// ./src/cards/pages/ProductDetail/utils.js